/* eslint-disable custom/no-hardcoded-colors */
import { withOnClickTracking } from 'auto-tracking';
import {
  ButtonGroup,
  Icon,
  SkeletonLoader,
  Spinner,
  styled,
  theme,
} from 'design-system';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { UploadButtonNew } from 'preflight-core';
import { useCallback, useEffect, useRef, useState } from 'react';

import { useEventTracking } from '../../../contexts/tracking-context';
import { Check, getJournal, Journal } from '../../../resources/journal';
import {
  getAllJournalSlugsForEndpointResType,
  journalObjectType,
} from '../../../utils/get-Journal-list-endpoint-v1';
import { mutateString } from '../../../utils/replace-language';
import { mapJournalToVariant } from '../../journal-variant';
import { CustomFontHeaderContainer } from '../../section';

export const Section1HomepageLHSPartner = ({
  languageCheckLists,
  technicalCheckLists,
  journal,
  onFileSelected,
  uploadState,
  showQuickView,
  setErrorScreen,
  errorSection,
  setErrorSection,
  setOtherSectionClicked,
  fetchJournalsForEndpointApi,
  journalList,
  publisherSlug,
  selectedJournal,
  setSelectedJournal,
  setIsLoadingJournalList,
  tempJournalDetails,
  setTempJournalDetails,
  selectedPaymentCurrency,

  isLoadingJournalList,
}: {
  journal: Journal;
  languageCheckLists: Check[];
  technicalCheckLists: Check[];

  onFileSelected: (file: File) => void;
  uploadState: { name: string };
  showQuickView: boolean;
  setErrorScreen: (value: boolean) => void;
  errorSection: string;
  setErrorSection: (value: string) => void;
  setOtherSectionClicked: (value: boolean) => void;
  techCheckCount: number;
  langCheckCount: number;
  fetchJournalsForEndpointApi: (data: {
    publisherSlug: string;
    journalSlug: string;
  }) => void;
  journalList: getAllJournalSlugsForEndpointResType;
  publisherSlug: string;
  selectedJournal: journalObjectType;
  setSelectedJournal: (data: journalObjectType) => void;
  isLoadingJournalList: boolean;
  setIsLoadingJournalList: (data: boolean) => void;

  tempJournalDetails: Journal | undefined;
  setTempJournalDetails: (data: Journal | undefined) => void;
  selectedPaymentCurrency: string | undefined;

  buttonDisabled: boolean;
}) => {
  const t = useTranslation('homepage').t;
  const { trackEvent } = useEventTracking();

  const mappedJournal = mapJournalToVariant(journal.publisher.slug);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const handleMouseEnter2 = () => {
    setShowTooltip2(true);
  };
  const handleMouseLeave2 = () => {
    setShowTooltip2(false);
  };
  const handleMouseEnter3 = () => {
    setShowTooltip3(true);
  };
  const handleMouseLeave3 = () => {
    setTimeout(() => {
      if (!tooltipRef.current?.matches(':hover')) {
        setShowTooltip3(false);
      }
    }, 100);
  };
  const handleTooltipMouseEnter = () => {
    setShowTooltip3(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip3(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setShowTooltip3(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const [inputFileName, setInputFileName] = useState('');
  const [error, setError] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const [dropdownPosition, setDropdownPosition] = useState<
    | 'above'
    | 'closeAbove'
    | 'below'
    | 'closeToLeft'
    | 'closeToRight'
    | 'closeToTop'
    | 'closeToBottom'
  >('below');

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setInputFileName('');
        setFileName('');
        setError('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const updateDropdownPosition = () => {
      if (!dropdownRef.current) {
        return;
      }

      const dropdownTriggerRect = dropdownRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;

      const spaceAbove = dropdownTriggerRect.top + scrollY;
      const spaceBelow = viewportHeight - dropdownTriggerRect.bottom;

      if (spaceBelow < 100) {
        setDropdownPosition('closeToBottom');
      } else if (spaceBelow < 250) {
        setDropdownPosition('closeAbove');
      } else if (spaceAbove > 250 && spaceBelow > 250) {
        setDropdownPosition('below');
      } else if (spaceAbove < 100) {
        setDropdownPosition('closeToTop');
      }
    };

    window.addEventListener('scroll', updateDropdownPosition);
    window.addEventListener('resize', updateDropdownPosition);

    updateDropdownPosition();

    return () => {
      window.removeEventListener('scroll', updateDropdownPosition);
      window.removeEventListener('resize', updateDropdownPosition);
    };
  }, []);

  const [isFocused, setIsFocused] = useState(false);
  const [fileName, setFileName] = useState('');

  const [journalLoader, setJournalLoader] = useState(false);

  const getJournalInfo = useCallback(
    async (journalSlug: string, articleTypeId?: string) => {
      if (tempJournalDetails?.slug === journalSlug && !articleTypeId) {
        return;
      }
      setJournalLoader(true);
      const res = await getJournal({
        journalSlug: journalSlug,
        publisherSlug: publisherSlug,
        currency: selectedPaymentCurrency,
        articleTypeId: articleTypeId,
      });

      setTimeout(() => {
        setJournalLoader(false);
      }, 1000);

      setTempJournalDetails(res);

      return res;
    },
    [
      tempJournalDetails?.slug,
      publisherSlug,
      selectedPaymentCurrency,
      setTempJournalDetails,
    ],
  );

  useEffect(() => {
    if (selectedJournal.slug !== tempJournalDetails?.slug) {
      setJournalLoader(true);
      setTempJournalDetails(undefined);

      setTimeout(() => {
        getJournalInfo(selectedJournal.slug).then(() => {
          setJournalLoader(false);
        });
      }, 1000);
    }
  }, [
    selectedJournal,
    tempJournalDetails?.slug,
    getJournalInfo,
    setTempJournalDetails,
  ]);

  useEffect(() => {
    if (inputFileName === '') {
      setIsLoadingJournalList(true);
      setFileName('');
      fetchJournalsForEndpointApi({ publisherSlug, journalSlug: '' });
    }
  }, [inputFileName]);

  useEffect(() => {
    const fetchAndSetJournals = async () => {
      await fetchJournalsForEndpointApi({
        publisherSlug,
        journalSlug: fileName,
      });
      setJournalLoader(false);
      setIsLoadingJournalList(false);
    };

    if (fileName && fileName.length >= 3) {
      setIsLoadingJournalList(true);
      fetchAndSetJournals();
    }
  }, [fileName]);

  const handleSearch = () => {
    if (inputFileName.length === 0) {
      setFileName('');
      setError('');
      //setIsLoadingJournalList(true);
      //fetchJournalsForEndpointApi({ publisherSlug, journalSlug: '' });
    } else if (inputFileName.length < 3) {
      setError('Please enter at least 3 characters');
    } else {
      setFileName(inputFileName);
      setError('');
      // Trigger search immediately
      //setIsLoadingJournalList(true);
    }
  };

  const getBorderColor = () => {
    if (error && isFocused) {
      return theme.colors.red10.value;
    }
    if (isFocused) {
      return theme.colors.blue9.value;
    }
    return theme.colors.gray8.value;
  };

  const handleJournalSelection = (selectedJournal: journalObjectType) => {
    setTempJournalDetails(undefined);
    setSelectedJournal(selectedJournal);
    setInputFileName('');
    setFileName('');
    setError('');
    setIsOpen(false);
    setSelectedArticleType(null);
    setArticleTypeValidationError(''); // Clear validation error when journal changes
  };

  const [isArticleTypeOpen, setIsArticleTypeOpen] = useState(false);
  const [selectedArticleType, setSelectedArticleType] = useState<{
    id?: number;
    name?: string;
    master?: boolean;
  } | null>(null);
  const articleTypeDropdownRef = useRef<HTMLDivElement>(null);

  const [articleTypeSearchInput, setArticleTypeSearchInput] = useState('');
  const [articleType, setArticleType] = useState('');
  const [isArticleTypeFocused, setIsArticleTypeFocused] = useState(false);
  const [articleTypeSearchError, setArticleTypeSearchError] = useState('');
  const [articleTypeValidationError, setArticleTypeValidationError] =
    useState('');
  const [isLoadingArticleTypeList, setIsLoadingArticleTypeList] =
    useState(false);

  const truncateText = (text: string, maxLength = 40): string => {
    if (text.length <= maxLength) {
      return text;
    }
    return `${text.substring(0, maxLength)}...`;
  };

  const handleToggleArticleTypeDropdown = () => {
    setIsArticleTypeOpen((prev) => {
      if (!prev && articleTypeSearchInput === '') {
        setFilteredArticleTypes(tempJournalDetails?.articleTypes || []);
      }
      return !prev;
    });
  };

  const handleArticleTypeSelection = (articleType: {
    id?: number;
    name?: string;
    master?: boolean;
  }) => {
    setSelectedArticleType(articleType);
    setIsArticleTypeOpen(false);
    setArticleTypeSearchInput('');
    setArticleTypeSearchError('');
    setArticleTypeValidationError('');

    if (articleType.id && selectedJournal.slug) {
      setJournalLoader(true);
      getJournalInfo(selectedJournal.slug, articleType.id.toString())
        .then(() => {
          setSelectedArticleType(articleType);
        })
        .finally(() => {
          setJournalLoader(false);
        });
    }
  };

  const handleArticleTypeSearch = () => {
    if (articleTypeSearchInput.length === 0) {
      setArticleType('');
      setArticleTypeSearchError('');
      setIsLoadingArticleTypeList(false);

      setFilteredArticleTypes(tempJournalDetails?.articleTypes || []);
    } else if (articleTypeSearchInput.length < 3) {
      setArticleType('');
      setArticleTypeSearchError('Please enter at least 3 characters');
      setIsLoadingArticleTypeList(false);
    } else {
      setArticleType(articleTypeSearchInput);
      setArticleTypeSearchError('');
      // Don't set loading to true since this is just local filtering
      setIsLoadingArticleTypeList(false);
    }
  };

  const getArticleTypeBorderColor = () => {
    if (articleTypeValidationError) {
      return '#CC244B';
    }
    if (articleTypeSearchError && isArticleTypeFocused) {
      return theme.colors.red10.value;
    }
    if (isArticleTypeFocused) {
      return theme.colors.blue9.value;
    }
    return theme.colors.gray8.value;
  };

  type ArticleType = {
    id?: number;
    name?: string;
    master?: boolean;
  };

  const [filteredArticleTypes, setFilteredArticleTypes] = useState<
    ArticleType[]
  >([]);

  useEffect(() => {
    if (articleTypeSearchInput === '') {
      setFilteredArticleTypes(tempJournalDetails?.articleTypes || []);
    }
  }, [tempJournalDetails?.articleTypes, articleTypeSearchInput]);

  useEffect(() => {
    if (articleType) {
      setFilteredArticleTypes(
        tempJournalDetails?.articleTypes?.filter((articleTypes) =>
          articleTypes.name?.toLowerCase().includes(articleType.toLowerCase()),
        ) || [],
      );

      setIsLoadingArticleTypeList(false);
    }
  }, [articleType, tempJournalDetails?.articleTypes]);

  const currentJournalData = tempJournalDetails || journal;
  const currentLangCheckCount = Object.values(
    currentJournalData.checklist.checks,
  ).filter((item) => item.grouping === 'language').length;
  const currentTechCheckCount = Object.values(
    currentJournalData.checklist.checks,
  ).filter((item) => item.grouping !== 'language').length;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        articleTypeDropdownRef.current &&
        !articleTypeDropdownRef.current.contains(event.target as Node)
      ) {
        setIsArticleTypeOpen(false);
        setArticleTypeSearchInput('');
        setArticleTypeSearchError('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <MainSection>
        <>
          <CustomFontHeaderContainer journal={mappedJournal}>
            <MainHeading
              style={{ fontSize: '30px', display: 'flex', width: '500px' }}
            >
              Get recommended pre-submission checks for your manuscript
              {/* Get Recommended Pre-submission <br />
              <span>
                Checks for <PublisherLabel>{journal.label}</PublisherLabel>
              </span> */}
            </MainHeading>
          </CustomFontHeaderContainer>

          <InputBoxLabel>
            Select your target journal <RequiredStyling>*</RequiredStyling>
          </InputBoxLabel>

          <DropdownContainer
            ref={dropdownRef}
            style={{
              position: isOpen ? 'absolute' : 'relative',
              zIndex: isOpen ? 1 : 'auto',
            }}
          >
            <DropdownTrigger
              data-test-id="hero-journal-dropdown-trigger"
              onClick={handleToggleDropdown}
              isOpen={isOpen}
            >
              {!isOpen ? (
                <>
                  {selectedJournal?.label ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        justifyItems: 'center',
                        flexDirection: 'row',
                        width: '100%',
                      }}
                    >
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                        title={selectedJournal.label}
                      >
                        {truncateText(selectedJournal.label, 30)}
                        <Image
                          width={14}
                          height={14}
                          src="/green-new-tick.svg"
                          alt="Green Tick"
                          style={{
                            marginLeft: '8px',
                            marginRight: '8px',
                          }}
                        />
                      </div>
                      <ChevronIcon isOpen={isOpen}>
                        <Icon variant={'regular'} name="chevronDown" />
                      </ChevronIcon>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        justifyItems: 'center',
                        flexDirection: 'row',
                        width: '100%',
                      }}
                    >
                      <span>Select Journal</span>
                      <ChevronIcon isOpen={isOpen}>
                        <Icon variant={'regular'} name="chevronDown" />
                      </ChevronIcon>
                    </div>
                  )}
                </>
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: 'auto',
                    minHeight: '24px',
                    maxHeight: '400px',
                    overflowY: 'auto',
                  }}
                >
                  <div>
                    <div
                      style={{
                        position: 'relative',
                        backgroundColor: 'rgba(244, 244, 244, 1)',
                        borderRadius: '10px',
                      }}
                    >
                      <Search
                        placeholder={t(
                          `section1_v1.please_enter_to_search_${publisherSlug}`,
                          'Type journal name and press enter to search',
                        )}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onFocus={(e) => {
                          e.stopPropagation();
                          setIsFocused(true);
                        }}
                        onBlur={() => setIsFocused(false)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSearch();
                          }
                        }}
                        value={inputFileName}
                        onChange={(e) => {
                          setInputFileName(e.target.value);
                          setError('');

                          if (e.target.value === '') {
                            setFileName('');
                            setIsLoadingJournalList(true);
                          }
                        }}
                        style={{
                          backgroundColor: theme.colors.white.value,
                          color: isFocused ? 'black' : theme.colors.gray8.value,
                          border: `1px solid ${getBorderColor()}`,
                          width: '370px',
                        }}
                        id="search_for_file_name"
                        data-test-id={`dashboard-search-for-file-name`}
                        type="text"
                        aria-label="Search for journal name"
                      />
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSearch();
                        }}
                        style={{
                          position: 'absolute',
                          right: '0px',
                          top: inputFileName.length !== 0 ? '28%' : '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor:
                            inputFileName.length > 0
                              ? theme.colors.blue10.value
                              : '#0062FF1A',
                          width: '40px',
                          height: '40px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: 'pointer',
                          borderTopRightRadius: '5px',
                          borderBottomRightRadius: '5px',
                        }}
                      >
                        <div
                          style={{
                            color:
                              inputFileName.length > 0
                                ? theme.colors.white.value
                                : theme.colors.gray8.value,
                          }}
                        >
                          <Icon name="search" size="sm" variant={'regular'} />
                        </div>
                      </div>
                      {inputFileName.length !== 0 && (
                        <div
                          style={{
                            backgroundColor: 'rgba(244, 244, 244, 1)',
                            color: 'rgba(93, 106, 129, 1)',
                            padding: '8px 12px',
                            borderBottomLeftRadius: '10px',
                            borderBottomRightRadius: '10px',
                            fontSize: '12px',
                            textAlign: 'center',
                          }}
                        >
                          {t(
                            `section1_v1.please_enter_to_search_${publisherSlug}`,
                            'Type journal name and press enter to search',
                          )}
                        </div>
                      )}
                    </div>
                    {isLoadingJournalList ? (
                      <div
                        style={{
                          display: 'flex',
                          width: '100%',
                          maxHeight: '217px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: '20px 0',
                          marginTop: '10px',
                        }}
                      >
                        <Spinner size={24} />
                      </div>
                    ) : (
                      journalList?.journals?.length > 0 && (
                        <JournalList dropdownPosition={dropdownPosition}>
                          {journalList?.journals.map(
                            (each: journalObjectType) => {
                              return (
                                <JournalListItem
                                  key={each.id}
                                  data-test-id={`hero-journal-item-${each.slug}`}
                                  title={each.label}
                                  onClick={(
                                    e: React.MouseEvent<
                                      HTMLDivElement,
                                      MouseEvent
                                    >,
                                  ) => {
                                    e.stopPropagation();
                                    handleJournalSelection(each);
                                  }}
                                  style={
                                    selectedJournal?.id === each.id ||
                                    (!selectedJournal?.id &&
                                      journal.slug === each.slug)
                                      ? {
                                          backgroundColor:
                                            'rgba(217, 229, 253, 1)',
                                          color: `rgba(0, 84, 241, 1)`,
                                        }
                                      : {}
                                  }
                                  aria-label={`Journal ${each.label}`}
                                >
                                  <span
                                    style={{
                                      width: '94%',
                                      fontSize: '14px',
                                      lineHeight: '24px',
                                      fontWeight: 500,
                                    }}
                                  >
                                    {truncateText(each.label, 35)}
                                  </span>
                                  {(selectedJournal?.id === each.id ||
                                    (!selectedJournal?.id &&
                                      journal.slug === each.slug)) && (
                                    <span>
                                      <Icon name={'check'} variant={'solid'} />
                                    </span>
                                  )}
                                </JournalListItem>
                              );
                            },
                          )}
                        </JournalList>
                      )
                    )}

                    {!journalList?.journals?.length &&
                      !isLoadingJournalList &&
                      fileName.length >= 3 && (
                        <>
                          <div
                            style={{
                              padding: '10px',
                              paddingLeft: '0px',
                              paddingRight: '0px',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <Heading2 style={{ textAlign: 'center' }}>
                                {t(
                                  `section1_v1.sorry_no_results_were_foun_${publisherSlug}`,
                                  `Sorry, no results were found`,
                                )}
                              </Heading2>
                              <Heading3 style={{ textAlign: 'center' }}>
                                {t(
                                  `section1_v1.sorry_no_results_were_fou_${publisherSlug}`,
                                  `You can search for another journal`,
                                )}
                              </Heading3>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>
              )}
            </DropdownTrigger>
          </DropdownContainer>

          {tempJournalDetails?.articleTypes &&
            tempJournalDetails.articleTypes.length > 1 && (
              <>
                <InputBoxLabel>
                  Select the article type <RequiredStyling>*</RequiredStyling>
                </InputBoxLabel>

                <DropdownContainer
                  ref={articleTypeDropdownRef}
                  style={{
                    position: isArticleTypeOpen ? 'absolute' : 'relative',
                    zIndex: isArticleTypeOpen ? 1 : 0,
                  }}
                >
                  <DropdownTrigger
                    data-test-id="hero-article-type-dropdown-trigger"
                    onClick={handleToggleArticleTypeDropdown}
                    isOpen={isArticleTypeOpen}
                    style={{
                      borderColor: getArticleTypeBorderColor(),
                    }}
                  >
                    {!isArticleTypeOpen ? (
                      <>
                        {selectedArticleType ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              justifyItems: 'center',
                              flexDirection: 'row',
                              width: '100%',
                            }}
                          >
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                              title={selectedArticleType.name || ''}
                            >
                              {truncateText(selectedArticleType.name || '', 30)}
                              <Image
                                width={14}
                                height={14}
                                src="/green-new-tick.svg"
                                alt="Green Tick"
                                style={{
                                  marginLeft: '8px',
                                  marginRight: '8px',
                                }}
                              />
                            </div>
                            <ChevronIcon isOpen={isArticleTypeOpen}>
                              <Icon variant={'regular'} name="chevronDown" />
                            </ChevronIcon>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              flexDirection: 'row',
                              width: '100%',
                            }}
                          >
                            <span>Select Article Type</span>
                            <ChevronIcon isOpen={isArticleTypeOpen}>
                              <Icon variant={'regular'} name="chevronDown" />
                            </ChevronIcon>
                          </div>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          width: '100%',
                          height: 'auto',
                          minHeight: '24px',
                        }}
                      >
                        <div>
                          <div
                            style={{
                              position: 'relative',
                              backgroundColor: 'rgba(244, 244, 244, 1)',
                              borderRadius: '10px',
                            }}
                          >
                            <Search
                              placeholder="Type article type and press enter to search"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                              onFocus={(e) => {
                                e.stopPropagation();
                                setIsArticleTypeFocused(true);
                              }}
                              onBlur={() => setIsArticleTypeFocused(false)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  handleArticleTypeSearch();
                                }
                              }}
                              value={articleTypeSearchInput}
                              onChange={(e) => {
                                setArticleTypeSearchInput(e.target.value);
                                setArticleTypeSearchError('');

                                if (e.target.value === '') {
                                  setArticleType('');
                                  setFilteredArticleTypes(
                                    tempJournalDetails?.articleTypes || [],
                                  );
                                }
                              }}
                              style={{
                                backgroundColor: theme.colors.white.value,
                                color: isArticleTypeFocused
                                  ? 'black'
                                  : theme.colors.gray8.value,
                                border: `1px solid ${getArticleTypeBorderColor()}`,
                              }}
                              id="search_for_article_type"
                              data-test-id="dashboard-search-for-article-type"
                              type="text"
                              aria-label="Search for article type"
                            />
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                handleArticleTypeSearch();
                              }}
                              style={{
                                position: 'absolute',
                                right: '0px',
                                top:
                                  articleTypeSearchInput.length !== 0
                                    ? '28%'
                                    : '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor:
                                  articleTypeSearchInput.length > 0
                                    ? theme.colors.blue10.value
                                    : '#0062FF1A',
                                width: '40px',
                                height: '39.5px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer',
                                borderTopRightRadius: '5px',
                                borderBottomRightRadius: '5px',
                              }}
                            >
                              <div
                                style={{
                                  color:
                                    articleTypeSearchInput.length > 0
                                      ? theme.colors.white.value
                                      : theme.colors.gray8.value,
                                }}
                              >
                                <Icon
                                  name="search"
                                  size="sm"
                                  variant={'regular'}
                                />
                              </div>
                            </div>
                            {articleTypeSearchInput.length !== 0 && (
                              <div
                                style={{
                                  backgroundColor: 'rgba(244, 244, 244, 1)',
                                  color: 'rgba(93, 106, 129, 1)',
                                  padding: '8px 12px',
                                  borderBottomLeftRadius: '10px',
                                  borderBottomRightRadius: '10px',
                                  fontSize: '12px',
                                  textAlign: 'center',
                                }}
                              >
                                Type article type and press enter to search
                              </div>
                            )}
                          </div>
                          <JournalList dropdownPosition={dropdownPosition}>
                            {isLoadingArticleTypeList ? (
                              <div
                                style={{
                                  display: 'flex',
                                  width: '100%',
                                  maxHeight: '217px',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  padding: '20px 0',
                                  marginTop: '10px',
                                }}
                              >
                                <Spinner size={24} />
                              </div>
                            ) : filteredArticleTypes.length > 0 ? (
                              filteredArticleTypes.map(
                                (
                                  articleType: {
                                    id?: number;
                                    name?: string;
                                    master?: boolean;
                                  },
                                  index: number,
                                ) => {
                                  return (
                                    <JournalListItem
                                      key={articleType.id || index}
                                      data-test-id={`hero-article-type-item-${
                                        articleType.id || 'no-id'
                                      }`}
                                      title={articleType.name || ''} // Show full name on hover
                                      onClick={(
                                        e: React.MouseEvent<
                                          HTMLDivElement,
                                          MouseEvent
                                        >,
                                      ) => {
                                        e.stopPropagation();
                                        handleArticleTypeSelection(articleType);
                                      }}
                                      style={
                                        selectedArticleType?.id ===
                                          articleType.id ||
                                        (!selectedArticleType &&
                                          tempJournalDetails?.articleTypes
                                            ?.length === 1 &&
                                          tempJournalDetails?.articleTypes?.[0]
                                            ?.id === articleType.id)
                                          ? {
                                              backgroundColor:
                                                'rgba(217, 229, 253, 1)',
                                              color: `rgba(0, 84, 241, 1)`,
                                            }
                                          : {}
                                      }
                                      aria-label={`Article Type ${articleType.name}`}
                                    >
                                      <span
                                        style={{
                                          width: '94%',
                                          fontSize: '14px',
                                          lineHeight: '24px',
                                          fontWeight: 500,
                                        }}
                                      >
                                        {truncateText(
                                          articleType.name || '',
                                          35,
                                        )}
                                      </span>
                                      {(selectedArticleType?.id ===
                                        articleType.id ||
                                        (!selectedArticleType &&
                                          tempJournalDetails?.articleTypes
                                            ?.length === 1 &&
                                          tempJournalDetails?.articleTypes?.[0]
                                            ?.id === articleType.id)) && (
                                        <span>
                                          <Icon
                                            name={'check'}
                                            variant={'solid'}
                                          />
                                        </span>
                                      )}
                                    </JournalListItem>
                                  );
                                },
                              )
                            ) : !isLoadingArticleTypeList &&
                              articleType.length >= 3 &&
                              filteredArticleTypes.length === 0 ? (
                              <div
                                style={{
                                  padding: '20px',
                                  textAlign: 'center',
                                  color: theme.colors.gray10.value,
                                  fontSize: '14px',
                                }}
                              >
                                No article types found matching{' '}
                                <strong>{articleTypeSearchInput}</strong>
                              </div>
                            ) : !isLoadingArticleTypeList &&
                              articleTypeSearchInput.length > 0 &&
                              articleTypeSearchInput.length < 3 ? (
                              <div
                                style={{
                                  padding: '20px',
                                  textAlign: 'center',
                                  color: theme.colors.gray10.value,
                                  fontSize: '14px',
                                }}
                              >
                                Please enter at least 3 characters to search
                              </div>
                            ) : null}
                          </JournalList>
                        </div>
                      </div>
                    )}
                  </DropdownTrigger>
                </DropdownContainer>

                {articleTypeValidationError && (
                  <ArticleTypeValidationError>
                    {articleTypeValidationError}
                  </ArticleTypeValidationError>
                )}
              </>
            )}

          {(tempJournalDetails?.articleTypes?.length === 1 ||
            (tempJournalDetails?.articleTypes &&
              tempJournalDetails.articleTypes.length > 1 &&
              selectedArticleType) ||
            (selectedJournal?.slug && journalLoader)) && (
            <AssessmentChecksMainDiv isLoading={journalLoader}>
              {journalLoader ? (
                <>
                  <div style={{ marginBottom: '8px' }}>
                    <SkeletonLoader
                      height="20px"
                      width="80%"
                      background={theme.colors.gray5.value}
                    />
                  </div>
                  <div style={{ marginBottom: '8px' }}>
                    <SkeletonLoader
                      height="24px"
                      width="60%"
                      background={theme.colors.gray5.value}
                    />
                  </div>
                  <div>
                    <SkeletonLoader
                      height="24px"
                      width="65%"
                      background={theme.colors.gray5.value}
                    />
                  </div>
                </>
              ) : (
                <>
                  <AssessmentChecksText>
                    {t(
                      'section1_v2.assessment_checks_recommended',
                      'Recommended checks for your selection:',
                    )}
                  </AssessmentChecksText>
                  {currentTechCheckCount > 0 && currentLangCheckCount > 0 ? (
                    <>
                      <LangTechCategoriesText>
                        <div
                          style={{
                            display: 'list-item',
                            marginLeft: '12px',
                            flexDirection: 'row',
                          }}
                        >
                          <span
                            data-test-id="language-check-count"
                            style={{
                              fontWeight: 600,
                              paddingRight: '4px',
                              cursor: 'pointer',
                              fontFamily: 'IBM Plex Sans',
                              fontStyle: 'normal',
                              fontSize: '12px',
                              lineHeight: '24px',
                              color: showTooltip2
                                ? theme.colors.blue10.value
                                : 'inherit',
                            }}
                            onMouseEnter={() => handleMouseEnter2()}
                            onMouseLeave={() => handleMouseLeave2()}
                          >
                            {currentLangCheckCount}
                          </span>
                        </div>
                        {mutateString(
                          t('section1_v1.is_manuscript_ready_description.lang'),
                          {},
                        )}
                      </LangTechCategoriesText>
                      {showTooltip2 ? (
                        <TooltipNew
                          ref={tooltipRef}
                          onMouseEnter={() => handleMouseEnter2()}
                          onMouseLeave={() => handleMouseLeave2()}
                        >
                          <ExpandableTextUL>
                            {languageCheckLists.map((check, index) => (
                              <ExpandableTextLI key={index}>
                                <span>{check.label}</span>
                              </ExpandableTextLI>
                            ))}
                          </ExpandableTextUL>
                        </TooltipNew>
                      ) : (
                        <></>
                      )}

                      <LangTechCategoriesText>
                        <div
                          style={{
                            display: 'list-item',
                            marginLeft: '12px',
                            flexDirection: 'row',
                          }}
                        >
                          <span
                            data-test-id="technical-check-count"
                            style={{
                              fontWeight: 600,
                              paddingRight: '4px',
                              cursor: 'pointer',
                              fontFamily: 'IBM Plex Sans',
                              fontStyle: 'normal',
                              fontSize: '12px',
                              lineHeight: '24px',
                              color: showTooltip3
                                ? theme.colors.blue10.value
                                : 'inherit',
                            }}
                            onMouseEnter={() => handleMouseEnter3()}
                            onMouseLeave={() => handleMouseLeave3()}
                          >
                            {currentTechCheckCount}
                          </span>
                        </div>
                        {mutateString(
                          t('section1_v1.is_manuscript_ready_description.tech'),
                          {},
                        )}
                      </LangTechCategoriesText>
                      {showTooltip3 ? (
                        <TooltipNew2
                          ref={tooltipRef}
                          onMouseEnter={handleTooltipMouseEnter}
                          onMouseLeave={handleTooltipMouseLeave}
                        >
                          <ExpandableTextUL>
                            {technicalCheckLists.map((check, index) => (
                              <ExpandableTextLI key={index}>
                                <span>{check.label}</span>
                              </ExpandableTextLI>
                            ))}
                          </ExpandableTextUL>
                        </TooltipNew2>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : currentTechCheckCount > 0 ? (
                    <>
                      <LangTechCategoriesText>
                        <div
                          style={{
                            display: 'list-item',
                            marginLeft: '12px',
                            flexDirection: 'row',
                          }}
                        >
                          <span
                            data-test-id="technical-check-count"
                            style={{
                              fontWeight: 600,
                              paddingRight: '4px',
                              cursor: 'pointer',
                              fontFamily: 'IBM Plex Sans',
                              fontStyle: 'normal',
                              fontSize: '12px',
                              lineHeight: '24px',
                              color: showTooltip3
                                ? theme.colors.blue10.value
                                : 'inherit',
                            }}
                            onMouseEnter={() => handleMouseEnter3()}
                            onMouseLeave={() => handleMouseLeave3()}
                          >
                            {currentTechCheckCount}
                          </span>
                        </div>
                        {mutateString(
                          t('section1_v1.is_manuscript_ready_description.tech'),
                          {},
                        )}
                      </LangTechCategoriesText>
                      {showTooltip3 ? (
                        <TooltipNew2
                          ref={tooltipRef}
                          onMouseEnter={handleTooltipMouseEnter}
                          onMouseLeave={handleTooltipMouseLeave}
                        >
                          <ExpandableTextUL>
                            {technicalCheckLists.map((check, index) => (
                              <ExpandableTextLI key={index}>
                                <span>{check.label}</span>
                              </ExpandableTextLI>
                            ))}
                          </ExpandableTextUL>
                        </TooltipNew2>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : currentLangCheckCount > 0 ? (
                    <>
                      <LangTechCategoriesText>
                        <div
                          style={{
                            display: 'list-item',
                            marginLeft: '12px',
                            flexDirection: 'row',
                          }}
                        >
                          <span
                            data-test-id="language-check-count"
                            style={{
                              fontWeight: 600,
                              paddingRight: '4px',
                              cursor: 'pointer',
                              fontFamily: 'IBM Plex Sans',
                              fontStyle: 'normal',
                              fontSize: '12px',
                              lineHeight: '24px',
                              color: showTooltip2
                                ? theme.colors.blue10.value
                                : 'inherit',
                            }}
                            onMouseEnter={() => handleMouseEnter2()}
                            onMouseLeave={() => handleMouseLeave2()}
                          >
                            {currentLangCheckCount}
                          </span>
                        </div>
                        {mutateString(
                          t('section1_v1.is_manuscript_ready_description.lang'),
                          {},
                        )}
                      </LangTechCategoriesText>
                      {showTooltip2 ? (
                        <TooltipNew
                          ref={tooltipRef}
                          onMouseEnter={() => handleMouseEnter2()}
                          onMouseLeave={() => handleMouseLeave2()}
                        >
                          <ExpandableTextUL>
                            {languageCheckLists.map((check, index) => (
                              <ExpandableTextLI key={index}>
                                <span>{check.label}</span>
                              </ExpandableTextLI>
                            ))}
                          </ExpandableTextUL>
                        </TooltipNew>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : null}
                </>
              )}
            </AssessmentChecksMainDiv>
          )}
        </>
        <ButtonGroup
          style={{ marginTop: '28px', display: 'flex', gap: '12px' }}
        >
          <ButtonWrap>
            {tempJournalDetails?.articleTypes &&
            tempJournalDetails.articleTypes.length > 1 &&
            !selectedArticleType ? (
              <ValidatedUploadButton
                id="Run-Pre-Submission Checks-Free"
                disabled={
                  !showQuickView &&
                  (uploadState.name === 'loading' ||
                    uploadState.name === 'success')
                }
                onClick={() => {
                  setArticleTypeValidationError(
                    'Please select article type to continue',
                  );
                  trackEvent([
                    'Manuscript upload intent',
                    'Upload click',
                    'Run pre-submission checks Free',
                    {
                      Section: 'Section 1',
                    },
                  ]);
                }}
                isIcon={true}
                isHoverPrimary={true}
                isAIPP={journal.publisher.slug === 'aipp' ? true : false}
              >
                <Icon
                  name="arrowUpFromBracket"
                  variant={'regular'}
                  height={16}
                />
                <span
                  dangerouslySetInnerHTML={{
                    __html: t('section1_v2.upload_for_free_assessment') ?? '',
                  }}
                />
              </ValidatedUploadButton>
            ) : (
              <UploadButtonNew
                id="Run-Pre-Submission Checks-Free"
                data-test-id="hero-upload-for-free-assessment-btn"
                disabled={
                  !showQuickView &&
                  (uploadState.name === 'loading' ||
                    uploadState.name === 'success')
                }
                onClick={() => {
                  trackEvent([
                    'Manuscript upload intent',
                    'Upload click',
                    'Run pre-submission checks Free',
                    {
                      Section: 'Section 1',
                    },
                  ]);
                  setOtherSectionClicked(false);
                  if (errorSection !== 'Section_1' && errorSection !== '') {
                    setOtherSectionClicked(true);
                    setErrorScreen(false);
                  }
                  setErrorSection('Section_1');
                }}
                onFileSelected={onFileSelected}
                size="small"
                text={t('section1_v2.upload_for_free_assessment')}
                isIcon={true}
                isHoverPrimary={true}
                style={{
                  fontSize: '20px',
                }}
                optionalLanguageText={{
                  processing: t('common.processing'),
                }}
                trackingProperties={{
                  CTALabel: 'Upload for free assessment',
                  elementName: 'manuscript_upload',
                  sectionName: 'section_1',
                }}
                isAIPP={journal.publisher.slug === 'aipp' ? true : false}
              />
            )}
          </ButtonWrap>
        </ButtonGroup>

        <FormatAccepted
          aria-label="Formats accepted"
          data-test-id="formats-accepted"
        >
          {t('section1_v1.formats_accepted', 'Formats accepted')}
          <Image
            width={36}
            height={36}
            src="/pdf-word-group.svg"
            alt={journal.label}
            style={{
              display: 'inline',
              marginLeft: '5px',
              marginRight: '5px',
            }}
          />
          {t('section1_v1.size_accepted', 'Size accepted')}
        </FormatAccepted>
      </MainSection>
    </>
  );
};

const MainSection = styled('div', {
  flex: 1,
  paddingTop: '10px',
});

const MainHeading = styled('span', {
  fontFamily: 'IBM Plex Sans',
  fontWeight: 700,
  fontStyle: 'bold',
  fontSize: '30px',
  lineHeight: '42px',
  color: 'rgba(5, 30, 87, 1)',
});

// const PublisherLabel = styled('span', {
//   fontFamily: 'IBM Plex Sans',
//   fontWeight: 700,
//   fontStyle: 'Bold',
//   color: 'rgba(111, 83, 37, 1)',
//   fontSize: '30px',
//   lineHeight: '42px',
//   marginLeft: '4px',
// });

const RequiredStyling = styled('span', {
  fontWeight: 400,
  color: 'rgba(5, 30, 87, 1)',
  lineHeight: '24px',
  fontSize: '14px',
});

const InputBoxLabel = styled('div', {
  fontWeight: 600,
  color: 'rgba(5, 30, 87, 1)',
  lineHeight: '24px',
  fontSize: '16px',
  marginBottom: '8px',
  display: 'block',
  marginTop: '16px',
  width: '400px',
});

const AssessmentChecksText = styled('div', {
  fontFamily: 'IBM Plex Sans',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '20px',
  color: 'rgba(93, 106, 129, 1)',
});

const LangTechCategoriesText = styled('div', {
  fontFamily: 'IBM Plex Sans',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '24px',
  letterSpacing: '0px',
  color: 'rgba(93, 106, 129, 1)',
  display: 'flex',
  flexDirection: 'row',
});

const AssessmentChecksMainDiv = styled('div', {
  padding: '16px',
  width: '400px',
  height: 'auto',
  borderRadius: '10px',
  marginTop: '24px',
  display: 'flex',
  flexDirection: 'column',

  variants: {
    isLoading: {
      true: {
        backgroundColor: 'transparent',
      },
      false: {
        backgroundColor: 'rgb(231, 241, 254)',
      },
    },
  },

  defaultVariants: {
    isLoading: false,
  },
});

const ButtonWrap = withOnClickTracking(
  styled('div', {
    minWidth: '300px',
    '& > Button': {
      minWidth: '300px',
      height: '60px',
    },
    '& > Button:hover': {
      backgroundColor: theme.colors.blue11,
    },
  }),
);

const FormatAccepted = styled('div', {
  fontSize: '12px',
  lineHeight: '12px',
  fontWeight: '500',
  marginTop: '10px',
  color: theme.colors.gray11,
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px',
});

const TooltipNew = styled('div', {
  position: 'absolute',
  backgroundColor: theme.colors.blue12,
  color: theme.colors.white,
  padding: '5px 10px',
  borderRadius: '4px',
  fontSize: '14px',
  height: 'max-content',
  fontFamily: 'IBM Plex Sans',
  textAlign: 'left',
  width: '168px',
  lineHeight: '22px',
  fontWeight: '400',
  fontStyle: 'normal',
  transform: 'translateY(10%)',
  marginTop: '8px',
});

const JournalListItem = withOnClickTracking(
  styled('div', {
    width: '99%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '10px',
    padding: '12px 10px',
    cursor: 'pointer',
    color: 'rgba(93, 106, 129, 1)',
    // borderRadius: 6,
    '&:hover': {
      backgroundColor: 'rgba(217, 229, 253, 1)',
      color: `${theme.colors.blue11.value}`,
    },
  }),
);

const JournalList = styled('div', {
  maxHeight: '217px',
  overflowY: 'auto',
  gap: '6px',
  opacity: '0px',
  paddingTop: 10,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '6px',

  variants: {
    dropdownPosition: {
      above: {
        position: 'relative',
      },
      below: {
        position: 'relative',
      },
      closeToLeft: {
        position: 'absolute',
        top: '0px',
        left: '-390px',
      },
      closeToRight: {
        position: 'absolute',
        top: '0px',
        right: '-390px',
      },
      closeToTop: {
        position: 'relative',
      },
      closeAbove: {
        position: 'relative',
      },
      closeToBottom: {
        position: 'relative',
      },
    },
  },

  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: theme.colors.gray1,
  },
  '&::-webkit-scrollbar-thumb': {
    background: `${theme.colors.gray6}`,
    height: '40px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: theme.colors.gray10,
  },
});

const Heading2 = styled('h1', {
  fontFamily: 'IBM Plex Sans',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '22px',
  textAlign: 'center',
  color: 'rgba(5, 30, 87, 1)',
});

const Heading3 = styled('div', {
  fontFamily: 'IBM Plex Sans',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '22px',
  textAlign: 'center',
  color: 'rgba(5, 30, 87, 1)',
});

const Search = styled('input', {
  width: '100%',
  color: theme.colors.gray12,
  gap: '0px',
  outline: 'none',
  border: '2px solid #e6e6e6',
  backgroundColor: theme.colors.white,
  maarginBottom: '0px',
  fontSize: 14,
  background: 'none',
  fontWeight: '400',
  justifyContent: 'flex-start',
  height: 40,
  fontFamily: 'IBM Plex Sans',
  borderRadius: '6px',
  padding: '0.5rem 0.75rem',
});

const DropdownContainer = styled('div', {
  paddingLeft: 0,
  paddingBottom: 0,
  borderRadius: '10px 10px 0 0',
  position: 'relative',
});

const DropdownTrigger = styled('div', {
  border: '1px solid #C4D1F0',
  borderRadius: '10px',
  // minHeight: '64px',
  padding: '14px',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  width: '400px',
  backgroundColor: '#FFF',
  transition: 'border-color 0.2s ease',
  position: 'relative',

  variants: {
    isOpen: {
      true: {
        borderColor: theme.colors.blue9.value,
        alignItems: 'flex-start',
        paddingTop: '20px',
        // height: '64px',
        overflow: 'visible',
      },
      false: {
        borderColor: '#C4D1F0',
        // height: '64px',
      },
    },
  },

  '&:hover': {
    borderColor: theme.colors.blue9.value,
  },
});

const ChevronIcon = styled('span', {
  width: '16px',
  height: '9px',
  color: 'rgba(93, 106, 129, 1)',
  transition: 'transform 0.2s ease',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  variants: {
    isOpen: {
      true: {
        transform: 'rotate(180deg)',
      },
      false: {
        transform: 'rotate(0deg)',
      },
    },
  },
});

const TooltipNew2 = styled('div', {
  position: 'absolute',
  transform: 'translateY(30%)',
  marginTop: '2px',
  backgroundColor: '#2C3E50',
  color: '#fff',
  padding: '8px 12px',
  borderRadius: '4px',
  fontSize: '14px',
  height: 'max-content',
  fontFamily: 'IBM Plex Sans',
  textAlign: 'left',
  width: '368px',
  lineHeight: '22px',
  fontWeight: '400',
  fontStyle: 'normal',
  maxHeight: '200px',
  overflowY: 'auto',
  wordWrap: 'break-word',
  whiteSpace: 'normal',
  zIndex: 9999,
});

const ExpandableTextUL = styled('ul', {
  margin: '0',
  padding: '0',
  listStyleType: 'none',
  paddingLeft: '20px',
});

const ExpandableTextLI = styled('li', {
  fontSize: '14px',
  fontWeight: '400',
  color: '#fff',
  margin: '10px 0',

  '&::before': {
    content: 'counter(list-item)',
    fontWeight: 'bold',
    marginRight: '10px',
  },
});

const ArticleTypeValidationError = styled('div', {
  fontFamily: 'IBM Plex Sans',
  fontWeight: 400,
  fontStyle: 'Regular',
  fontSize: '12px',
  lineHeight: '20px',
  letterSpacing: '0%',
  color: '#CC244B',
  marginTop: '4px',
  marginLeft: '2px',
});

const ValidatedUploadButton = styled('button', {
  fontSize: '20px',
  border: 'none',
  backgroundColor: theme.colors.blue9,
  color: theme.colors.white,
  padding: '14px 28px',
  borderRadius: '7px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontFamily: 'IBM Plex Sans',
  fontWeight: 600,
  minWidth: '300px',
  height: '60px',

  '&:hover': {
    backgroundColor: theme.colors.blue10,
  },

  '&:disabled': {
    backgroundColor: theme.colors.blue6,
    cursor: 'not-allowed',
  },

  variants: {
    isAIPP: {
      true: {
        border: '3px solid white',
      },
    },
    isIcon: {
      true: {
        fontSize: '16px !important',
        borderRadius: '7px',
      },
    },
    isHoverPrimary: {
      true: {
        '&:hover': {
          backgroundColor: `${theme.colors.blue10} !important`,
        },
        '&:disabled': {
          backgroundColor: `${theme.colors.blue6} !important`,
          color: `${theme.colors.white} !important`,
        },
      },
    },
  },
});
